/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEvent201Response,
  CreateEventDto,
  Event,
  EventProjection,
  UpdateEventDto,
  UserEmailsDto,
} from '../models/index';
import {
    CreateEvent201ResponseFromJSON,
    CreateEvent201ResponseToJSON,
    CreateEventDtoFromJSON,
    CreateEventDtoToJSON,
    EventFromJSON,
    EventToJSON,
    EventProjectionFromJSON,
    EventProjectionToJSON,
    UpdateEventDtoFromJSON,
    UpdateEventDtoToJSON,
    UserEmailsDtoFromJSON,
    UserEmailsDtoToJSON,
} from '../models/index';

export interface CreateEventRequest {
    createEventDto: CreateEventDto;
}

export interface DeleteEventRequest {
    id: number;
}

export interface GetEventByIdRequest {
    id: number;
}

export interface GetEventsByPartnerIdRequest {
    partnerId: number;
}

export interface GetEventsByUserEmailAndCurrentMonthRequest {
    userEmail: string;
}

export interface GetEventsByUserEmailsRequest {
    userEmailsDto: UserEmailsDto;
}

export interface GetEventsByUsersIdsRequest {
    ids: Array<string>;
}

export interface GetEventsCategoryByUsersIdsRequest {
    ids: Array<string>;
    year?: number;
}

export interface UpdateEventRequest {
    id: number;
    updateEventDto: UpdateEventDto;
}

/**
 * 
 */
export class EventApi extends runtime.BaseAPI {

    /**
     * Create a new event
     */
    async createEventRaw(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEvent201Response>> {
        if (requestParameters['createEventDto'] == null) {
            throw new runtime.RequiredError(
                'createEventDto',
                'Required parameter "createEventDto" was null or undefined when calling createEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/event`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEventDtoToJSON(requestParameters['createEventDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEvent201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new event
     */
    async createEvent(requestParameters: CreateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEvent201Response> {
        const response = await this.createEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an event
     */
    async deleteEventRaw(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an event
     */
    async deleteEvent(requestParameters: DeleteEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEventRaw(requestParameters, initOverrides);
    }

    /**
     * Get an event by id
     */
    async getEventByIdRaw(requestParameters: GetEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Event>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFromJSON(jsonValue));
    }

    /**
     * Get an event by id
     */
    async getEventById(requestParameters: GetEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Event> {
        const response = await this.getEventByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get events by partner id
     */
    async getEventsByPartnerIdRaw(requestParameters: GetEventsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getEventsByPartnerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/partner/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * Get events by partner id
     */
    async getEventsByPartnerId(requestParameters: GetEventsByPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.getEventsByPartnerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get events by user email for the current month
     */
    async getEventsByUserEmailAndCurrentMonthRaw(requestParameters: GetEventsByUserEmailAndCurrentMonthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        if (requestParameters['userEmail'] == null) {
            throw new runtime.RequiredError(
                'userEmail',
                'Required parameter "userEmail" was null or undefined when calling getEventsByUserEmailAndCurrentMonth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/user/currentMonth/{userEmail}`;
        urlPath = urlPath.replace(`{${"userEmail"}}`, encodeURIComponent(String(requestParameters['userEmail'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * Get events by user email for the current month
     */
    async getEventsByUserEmailAndCurrentMonth(requestParameters: GetEventsByUserEmailAndCurrentMonthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.getEventsByUserEmailAndCurrentMonthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get events by user emails
     */
    async getEventsByUserEmailsRaw(requestParameters: GetEventsByUserEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        if (requestParameters['userEmailsDto'] == null) {
            throw new runtime.RequiredError(
                'userEmailsDto',
                'Required parameter "userEmailsDto" was null or undefined when calling getEventsByUserEmails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/event/users/by-emails`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserEmailsDtoToJSON(requestParameters['userEmailsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * Get events by user emails
     */
    async getEventsByUserEmails(requestParameters: GetEventsByUserEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.getEventsByUserEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get events by users id
     */
    async getEventsByUsersIdsRaw(requestParameters: GetEventsByUsersIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Event>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getEventsByUsersIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/users/{ids}`;
        urlPath = urlPath.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters['ids'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFromJSON));
    }

    /**
     * Get events by users id
     */
    async getEventsByUsersIds(requestParameters: GetEventsByUsersIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Event>> {
        const response = await this.getEventsByUsersIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get category events by users id
     */
    async getEventsCategoryByUsersIdsRaw(requestParameters: GetEventsCategoryByUsersIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventProjection>>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getEventsCategoryByUsersIds().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/event/users/{ids}/category`;
        urlPath = urlPath.replace(`{${"ids"}}`, encodeURIComponent(String(requestParameters['ids'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventProjectionFromJSON));
    }

    /**
     * Get category events by users id
     */
    async getEventsCategoryByUsersIds(requestParameters: GetEventsCategoryByUsersIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventProjection>> {
        const response = await this.getEventsCategoryByUsersIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an event
     */
    async updateEventRaw(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Event>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateEvent().'
            );
        }

        if (requestParameters['updateEventDto'] == null) {
            throw new runtime.RequiredError(
                'updateEventDto',
                'Required parameter "updateEventDto" was null or undefined when calling updateEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/event/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEventDtoToJSON(requestParameters['updateEventDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFromJSON(jsonValue));
    }

    /**
     * Update an event
     */
    async updateEvent(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Event> {
        const response = await this.updateEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
